/**
 * House of Places — header menu panels.
 *
 * HOP (2026-10-21): the Shop panel (countries) opens on CLICK only, not on
 * hover. Clicking "Shop" toggles the panel (Dawn's own <details> behaviour);
 * it no longer navigates to /collections/all. Once open, the panel closes a
 * moment after the pointer leaves it, on Escape, or on a second click.
 * The header search still opens on hover.
 *
 * Only real hover devices get the hover parts. A touch device reports
 * `hover: none`; there the click behaviour Dawn ships is used as is.
 */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var KAPANMA_GECIKMESI = 250;

  var acilirlar = [].concat(
    Array.prototype.slice.call(document.querySelectorAll('.hop-mega')),
    Array.prototype.slice.call(document.querySelectorAll('.header__search > details')),
  );

  function digerleriniKapat(details) {
    // One panel at a time. The search closes through Dawn's details-modal so
    // its focus trap and body lock are released too.
    acilirlar.forEach(function (diger) {
      if (diger === details || !diger.open) return;
      var modal = diger.closest('details-modal');
      if (modal && typeof modal.close === 'function') {
        modal.close(false);
      } else {
        diger.open = false;
        diger.dispatchEvent(new Event('toggle'));
      }
    });
  }

  acilirlar.forEach(function (details) {
    var tiklaAc = details.classList.contains('hop-mega');
    var menu = details.closest('header-menu') || details.closest('.header__search') || details;
    var panel = details.querySelector('.mega-menu__content, .search-modal');
    var zamanlayici = null;

    function ac() {
      clearTimeout(zamanlayici);
      if (details.open) return;
      digerleriniKapat(details);
      details.open = true;
      // Dawn listens for toggle to record the header's bottom edge, which the
      // panel's max-height depends on.
      details.dispatchEvent(new Event('toggle'));
    }

    function kapat() {
      if (!details.open) return;
      // Never yank the panel out from under a keyboard user inside it.
      if (details.contains(document.activeElement) && document.activeElement.tagName !== 'SUMMARY') return;
      details.open = false;
      details.dispatchEvent(new Event('toggle'));
    }

    function gecikmeliKapat() {
      clearTimeout(zamanlayici);
      zamanlayici = setTimeout(kapat, KAPANMA_GECIKMESI);
    }

    function kapanmayiIptal() {
      clearTimeout(zamanlayici);
    }

    if (tiklaAc) {
      // Click-only: hovering never opens it; staying over it keeps it open.
      var ozet = details.querySelector('summary');
      if (ozet) {
        ozet.addEventListener('click', function () {
          if (!details.open) digerleriniKapat(details);
        });
      }
      menu.addEventListener('mouseenter', kapanmayiIptal);
      menu.addEventListener('mouseleave', gecikmeliKapat);
      if (panel) {
        panel.addEventListener('mouseenter', kapanmayiIptal);
        panel.addEventListener('mouseleave', gecikmeliKapat);
      }
      return;
    }

    menu.addEventListener('mouseenter', ac);
    menu.addEventListener('mouseleave', gecikmeliKapat);
    if (panel) {
      panel.addEventListener('mouseenter', ac);
      panel.addEventListener('mouseleave', gecikmeliKapat);
    }
  });
})();
